import React from 'react'

const DocumentUpload = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
            d="M13.2598 9.8982V17.1582H10.8598V9.8982H8.45979L12.0598 3.5982L15.6598 9.8982H13.2598Z"
            fill="#0562D2"
        />
        <path d="M19.3799 16.918V19.318H4.85985V16.918H3.59985V20.518H20.5199V16.918H19.3799V16.918Z" fill="#0562D2" />
    </svg>
)

export default DocumentUpload
